module.exports = __webpack_public_path__ + "static/media/sheep.5ca8013c.png";